import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import HighlightLabel from 'LuxKit/Label/HighlightLabel'
import { dateDifference, dateIsBefore } from 'lib/datetime/dateUtils'
import { useIntl } from 'react-intl'
import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'

type ActiveCountdown =
  | { unit: 'day'; days: number }
  | { unit: 'hour'; hours: number }

function getActiveCountdown(now: Date, endsAt: Date): ActiveCountdown | undefined {
  if (!dateIsBefore(now, endsAt)) return undefined

  const { days, hours } = dateDifference(endsAt, now)
  if (days > 0) return { unit: 'day', days }

  return { unit: 'hour', hours }
}

interface Props {
  endsAt?: Date
  mode: 'countdown' | 'until'
}

function LoyaltyChooseDoubleRewardsLandingPageActiveLabel({ endsAt, mode }: Props) {
  const intl = useIntl()
  const [countdown, setCountdown] = useState<ActiveCountdown>()

  // Run when either changes (re-render if endAt loads in)
  useEffect(() => {
    if (endsAt && mode === 'countdown') {
      setCountdown(getActiveCountdown(new Date(), endsAt))
    }
  }, [endsAt, mode])

  if (!endsAt) return null

  let label: ReactNode
  if (mode === 'countdown') {
    if (!countdown) return null
    if (countdown.unit === 'hour') {
      label = intl.formatMessage(
        {
          id: 'tBP_xkHtkmSbn1nSj-hE',
          defaultMessage: 'Ends in {hours, plural, one {# hour} other {# hours}}',
          description: 'Countdown on the double rewards landing page hero when less than a day remains',
        },
        { hours: countdown.hours },
      )
    } else {
      label = intl.formatMessage(
        {
          id: 'tYcAyPPiTJDUicN_oM4j',
          defaultMessage: 'Active for {days, plural, one {# day} other {# days}}',
          description: 'Remaining active days of the chosen reward in the double rewards landing page hero',
        },
        { days: countdown.days },
      )
    }
  } else {
    label = intl.formatMessage(
      {
        id: 'yuV1za4gSaYBrdgYmPZH',
        defaultMessage: 'Active until {date}',
        description: 'Expiry label for the selected double reward on the campaign landing page',
      },
      { date: <FormatDateTime value={endsAt} day="numeric" month="short" /> },
    )
  }

  return <HighlightLabel>{label}</HighlightLabel>
}

export default LoyaltyChooseDoubleRewardsLandingPageActiveLabel
